import React, { useEffect, useMemo, useState } from 'react';
import { Table, Button, FormInput, ColumnProps, Form, Row, Col, FormResetButton } from '@digital/ui';
import { CicloOrcamentarioRelatorio, CicloOrcamentarioRelatorioResult } from '../../api/relatorioCicloorcamentario';
import { compareNumber, compareText } from '@app/helpers/comparators';
import { Icon } from 'antd';
import { PaginationConfig } from 'antd/lib/pagination';
import { formatCurrencyBr } from '@app/helpers/numbers';

interface TableCicloOrcamentarioPluriAnualProps {
  cicloOrcamentarioRelatorioTotal: CicloOrcamentarioRelatorio;
  paginacaoConfig: PaginationConfig,
  relatorioControleRfa?: boolean,
  ocultarColunaDetalhe?: boolean
}

const TableBuilUp = (props: TableCicloOrcamentarioPluriAnualProps) => {
  const { cicloOrcamentarioRelatorioTotal, paginacaoConfig, relatorioControleRfa, ocultarColunaDetalhe } = props;

  const [valorTotalA, setValorTotalA] = useState(cicloOrcamentarioRelatorioTotal.valorTotalA);
  const [valorTotalB, setValorTotalB] = useState(cicloOrcamentarioRelatorioTotal.valorTotalB);
  const [valorTotalC, setValorTotalC] = useState(cicloOrcamentarioRelatorioTotal.valorTotalC);
  const [valorTotalD, setValorTotalD] = useState(cicloOrcamentarioRelatorioTotal.valorTotalD);
  const [valorTotalE, setValorTotalE] = useState(cicloOrcamentarioRelatorioTotal.valorTotalE);
  const [valorTotalF, setValorTotalF] = useState(cicloOrcamentarioRelatorioTotal.valorTotalF);
  const [valorTotalG, setValorTotalG] = useState(cicloOrcamentarioRelatorioTotal.valorTotalG);
  const [valorTotalH, setValorTotalH] = useState(cicloOrcamentarioRelatorioTotal.valorTotalH);
  const [valorTotalI, setValorTotalI] = useState(cicloOrcamentarioRelatorioTotal.valorTotalI);
  const [valorTotalJ, setValorTotalJ] = useState(cicloOrcamentarioRelatorioTotal.valorTotalJ);


  useMemo(() => {
    paginacaoConfig.onChange = (() => {
      document.getElementById("tabelaControleRfa").scrollIntoView();
    })
  }, [paginacaoConfig]);

  const colunas = useMemo(() => {
    if (cicloOrcamentarioRelatorioTotal) {
      let colluns: ColumnProps<CicloOrcamentarioRelatorioResult>[] = new Array();

      colluns.push(
        {
          title: 'N',
          dataIndex: 'numeroLinha',
          sorter: (a, b) => compareNumber(a.numeroLinha, b.numeroLinha),
        });


      colluns.push({
        title: 'CÓD',
        dataIndex: 'codProjeto',
        sorter: (a, b) => compareText(a.codProjeto, b.codProjeto),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar CÓD"
                name="codProjeto"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.codProjeto !== undefined &&
          record.codProjeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      });


      colluns.push({
        title: 'NOME',
        dataIndex: 'nomeprojeto',
        sorter: (a, b) => compareText(a.nomeprojeto, b.nomeprojeto),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar Nome"
                name="codProjeto"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) =>
          record.nomeprojeto !== undefined &&
          record.nomeprojeto
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      });

      if (relatorioControleRfa === true) {
        colluns.push({
          title: 'Número RFA',
          dataIndex: 'planilhaRfaAtual',
          sorter: (a, b) => compareText(a.planilhaRfaAtual, b.planilhaRfaAtual),
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar CONTROLE RFA"
                  name="planilhaRfaAtual"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.planilhaRfaAtual !== undefined &&
            record.planilhaRfaAtual
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        });
      }

      colluns.push({
        dataIndex: 'totalizadorColunaA',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalA}</div>
        },
        children: [
          {
            title: 'A',
            children: [
              {
                title: 'CapEx',
                dataIndex: 'capEx',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaB',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalB}</div>
        },
        children: [
          {
            title: 'B',
            children: [
              {
                title: 'Contratado',
                dataIndex: 'contratado',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaC',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalC}</div>
        },
        children: [
          {
            title: 'C',
            children: [
              {
                title: 'Executado',
                dataIndex: 'executado',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunad',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalD}</div>
        },
        children: [
          {
            title: 'D',
            children: [
              {
                title: 'Requisitado',
                dataIndex: 'requisitado',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaEbcd',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalE}</div>
        },
        children: [
          {
            title: 'e = b - c + d',
            children: [
              {
                title: 'Compromissado',
                dataIndex: 'compromissado',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunaF',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalF}</div>
        },
        children: [
          {
            title: 'F',
            children: [
              {
                title: 'A Contratar',
                dataIndex: 'aContratar',
                align: 'center',
              },
            ],
          },
        ],
      });

      colluns.push({
        dataIndex: 'totalizadorColunaGbdff',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalG}</div>
        },
        children: [
          {
            title: 'g = b + d + f',
            children: [
              {
                title: 'Forecast',
                dataIndex: 'forecast',
                align: 'center',
              },
            ],
          },
        ],
      });


      colluns.push({
        dataIndex: 'totalizadorColunahag',
        align: 'center',
        title: (column) => {
          return <div id={'ColunaTotalizadorColunaI'}> {valorTotalH}</div>
        },
        children: [
          {
            title: 'h = a - g',
            children: [
              {
                title: 'saldo capEx',
                dataIndex: 'saldoCapEx',
                align: 'center',
              },
              {
                title: '%',
                dataIndex: 'saldoCapExPercentual',
                align: 'center',
                sorter: (a, b) => compareText(a.saldoCapExPercentual, b.saldoCapExPercentual),
              },
              {
                title: '',
                dataIndex: 'saldoCapExPercentual',
                align: 'center',
                render: (text, row, index) => {
                  return <> {row.mostrarCor === true ?
                    (<Icon type="check-circle" theme="twoTone" twoToneColor={row.saldoCapExPercentualCor} />) : (<> </>)} </>
                },
              },
            ],
          },
        ],
      });


      if (relatorioControleRfa === true) {

        colluns.push({
          dataIndex: 'totalizadorColunaI',
          align: 'center',
          title: (column) => {
            return <div id={'ColunaTotalizadorColunaI'}> {valorTotalI}</div>
          },
          children: [
            {
              title: 'I',
              children: [
                {
                  title: 'Orçado Ano',
                  dataIndex: 'capexCicloAno',
                  align: 'center',
                },
              ],
            },
          ],
        });

        colluns.push({
          dataIndex: 'totalizadorColunaJ',
          align: 'center',
          title: (column) => {
            return <div id={'ColunaTotalizadorColunaI'}> {valorTotalJ}</div>
          },
          children: [
            {
              title: 'J',
              children: [
                {
                  title: 'Forecast Ano',
                  dataIndex: 'forecastCicloAno',
                  align: 'center',
                },
              ],
            },
          ],
        });
      }

      if (ocultarColunaDetalhe != true) {
        colluns.push({
          title: `Detalhe`,
          align: 'center',
          render: (text, row, index) => {
            return (
              <>
                {
                  row.mostrarDetalhe === true ? (
                    <Button
                      onClick={() => {
                        window.open(`/relatorioProjetoPluriAnualDetalheProjeto/dadosgerais?projetoId=${row.id}`);
                      }}
                      icon="commons-search"
                    />
                  ) : (<> </>)
                }
              </>
            );
          },
        });
      }


      return colluns;
    }
    return [];
  }, [
    cicloOrcamentarioRelatorioTotal,
    valorTotalA,
    valorTotalB,
    valorTotalC,
    valorTotalD,
    valorTotalE,
    valorTotalF,
    valorTotalG,
    valorTotalH,
    valorTotalI,
    valorTotalJ]);


  useEffect(() => {
    if (cicloOrcamentarioRelatorioTotal && cicloOrcamentarioRelatorioTotal.result) {
      calcularTotalColunasAoIniciar();
    }
  }, []);

  const calcularTotalColunasAoIniciar = () => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;

    cicloOrcamentarioRelatorioTotal.result.map((item) => {
      if (item.children && item.children.length > 0) {
        item.children.map((itemFilho) => {
          totalA += itemFilho.capExDecimal;
          totalB += itemFilho.contratadoDecimal;
          totalC += itemFilho.executadoDecimal;
          totalD += itemFilho.requisitadoDecimal;
          totalE += itemFilho.compromissadoDecimal;
          totalF += itemFilho.aContratarDecimal;
          totalG += itemFilho.forecastDecimal;
          totalH += itemFilho.saldoCapExDecimal;
        });
      }
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
    });

    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
  }



  const calcularCabecalhoDaTabela = (extra: TableCurrentDataSource<CicloOrcamentarioRelatorioResult>) => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;
    let totalI = 0;
    let totalJ = 0;

    extra.currentDataSource.map((item) => {
      totalA += item.capExDecimal;
      totalB += item.contratadoDecimal;
      totalC += item.executadoDecimal;
      totalD += item.requisitadoDecimal;
      totalE += item.compromissadoDecimal;
      totalF += item.aContratarDecimal;
      totalG += item.forecastDecimal;
      totalH += item.saldoCapExDecimal;
      totalI += item.capexCicloAnoRfaDecimal;
      totalJ += item.forecastCicloAnoRfaDecimal;
    });


    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));
    setValorTotalI(formatCurrencyBr(totalI));
    setValorTotalJ(formatCurrencyBr(totalJ));

  }

  return <Table
    rowKey="id"
    id="tabelaControleRfa"
    columns={colunas}
    dataSource={cicloOrcamentarioRelatorioTotal.result}
    pagination={paginacaoConfig}
    onChange={(pagination, filters, sorter, extra) => {
      calcularCabecalhoDaTabela(extra);

    }}
  />;
};

export default TableBuilUp;
